import { Formik } from 'formik';
import React from 'react';

import { ValidationForgetPassword } from 'common/validations';
import PrimaryButton from 'components/form/buttons/primaryButton';
import PasswordInput from 'components/form/passwordInput';
import Gap from 'components/gap';
import { useActions } from 'common/hooks/useActions';

// import * as S from "../../styles";

const ForgetasswordChangeForm: React.FC = () => {
  const { forgetPasswordRequestAction } = useActions();

  return (
    <Formik
      initialValues={{ password: '', confirmPassword: '' }}
      validationSchema={ValidationForgetPassword}
      onSubmit={(values, { setSubmitting }) => {
        forgetPasswordRequestAction(values, () => {});
        setSubmitting(false);
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        <>
          <Gap size="24px" />
          {/*
            Both fields were `TextIput type="text"` until this pass, so a new
            password and its confirmation were typed in clear on screen. They
            are the same PasswordInput the login screen uses, reveal included.
          */}
          <PasswordInput
            label="New password"
            name="password"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Please type a new password"
            value={values.password}
            message={touched.password && errors.password}
            error={errors.password as unknown as boolean}
          />
          <Gap size="16px" />
          <PasswordInput
            label="Confirm new password"
            name="confirmPassword"
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder="Please Retype your new password"
            value={values.confirmPassword}
            message={errors.confirmPassword}
            error={errors.confirmPassword as unknown as boolean}
          />
          <Gap size="24px" />
          <PrimaryButton onClick={handleSubmit} disabled={isSubmitting} style={{ width: '100%' }}>
            Change Password
          </PrimaryButton>
        </>
      )}
    </Formik>
  );
};

export default ForgetasswordChangeForm;
